<template>
  <region-component/>
</template>

<script>
import RegionComponent from '@/spa/components/board/region/BoardRegion';

export default {
  name: 'RegionPage',
  components: {
    RegionComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/RegionPage.vue